import Globais from "../../components/Globais";
import { Container, ContainerTitulo, TituloForm } from "../ViewGerenciar/styles";

export default function ViewConfiguracoesHub() {
  return (
    <Container>
      <ContainerTitulo>
        <TituloForm>Configurações</TituloForm>
      </ContainerTitulo>

      <main className="card-grid">
        <div className="card">
          <div style={{ textAlign: "center" }}>
            <i
              className="fas fa-cogs"
              style={{
                fontSize: "2rem",
                marginBottom: "1rem",
                color: "#003644",
              }}
            ></i>
          </div>
          <h2>Variáveis do sistema</h2>
          <p>Gerencie as variáveis, parâmetros e limites globais do sistema.</p>
          <a href={Globais.DOMINIOFRONT + "/gerenciarConfigSistemaVariaveis"}>
            Acessar
          </a>
        </div>

        <div className="card">
          <div style={{ textAlign: "center" }}>
            <i
              className="fas fa-list-check"
              style={{
                fontSize: "2rem",
                marginBottom: "1rem",
                color: "#003644",
              }}
            ></i>
          </div>
          <h2>Características</h2>
          <p>
            Acesse os atalhos para gerenciar as características de
            empreendimentos e apartamentos.
          </p>
          <a href={Globais.DOMINIOFRONT + "/gerenciarCaracteristicas"}>
            Acessar
          </a>
        </div>
      </main>
    </Container>
  );
}
